import * as types from '../mutation-types';
import ConversationAPI from '../../api/inbox/conversation';

// Collision detection: which agents currently have each conversation open.
// records: { [conversationId]: [{ id, name, available_name, avatar_url, thumbnail, type }] }
const state = {
  records: {},
};

export const getters = {
  // All agents viewing a conversation (includes self; components filter self out).
  getViewers: $state => id => {
    return $state.records[Number(id)] || [];
  },
};

export const actions = {
  // Tell the server this agent is viewing / has left the conversation.
  togglePresence: async (_, { conversationId, status }) => {
    try {
      await ConversationAPI.togglePresence({ conversationId, status });
    } catch (error) {
      // best effort — presence is non-critical
    }
  },
  // Handle a broadcasted viewer list from the websocket.
  update: ({ commit }, { conversationId, users }) => {
    commit(types.default.SET_CONVERSATION_VIEWERS, { conversationId, users });
  },
};

export const mutations = {
  [types.default.SET_CONVERSATION_VIEWERS]: ($state, { conversationId, users }) => {
    $state.records = {
      ...$state.records,
      [conversationId]: users || [],
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
